import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { InspirationProvider } from "@/context/InspirationContext";
import { FeaturedImagesProvider } from "@/context/FeaturedImagesContext";
import { SiteProvider } from "@/context/SiteContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Atelier from "@/pages/Atelier";
import Servizi from "@/pages/Servizi";
import Galleria from "@/pages/Galleria";
import Eventi from "@/pages/Eventi";
import Prenota from "@/pages/Prenota";
import Contatti from "@/pages/Contatti";
import Privacy from "@/pages/Privacy";
import CookieBanner from "@/components/CookieBanner";
import Matrimoni from "@/pages/Matrimoni";
import Workshop from "@/pages/Workshop";
import Giardini from "@/pages/Giardini";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function App() {
    return (
        <div className="App">
            <SiteProvider>
                <FeaturedImagesProvider>
                    <InspirationProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <Routes>
                            <Route element={<Layout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/atelier" element={<Atelier />} />
                                <Route path="/servizi" element={<Servizi />} />
                                <Route path="/galleria" element={<Galleria />} />
                                <Route path="/eventi" element={<Eventi />} />
                                <Route path="/prenota" element={<Prenota />} />
                                <Route path="/contatti" element={<Contatti />} />
                                <Route path="/matrimoni" element={<Matrimoni />} />
                                <Route path="/workshop" element={<Workshop />} />
                                <Route path="/giardini" element={<Giardini />} />
                                <Route path="/privacy" element={<Privacy />} />
                                <Route path="*" element={<NotFound />} />
                            </Route>
                            <Route path="/admin" element={<AdminLogin />} />
                            <Route path="/admin/dashboard" element={<AdminDashboard />} />
                        </Routes>
                        <Toaster richColors position="top-center" />
                        <CookieBanner />
                    </BrowserRouter>
                </InspirationProvider>
            </FeaturedImagesProvider>
            </SiteProvider>
        </div>
    );
}

export default App;
